import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { Components } from '@mui/material/styles';
import { type Theme } from '@mui/material/styles';
import { faCheckCircle } from '@rtkwlf/pro-solid-svg-icons/faCheckCircle';
import { faDiamondExclamation } from '@rtkwlf/pro-solid-svg-icons/faDiamondExclamation';
import { faExclamationTriangle } from '@rtkwlf/pro-solid-svg-icons/faExclamationTriangle';
import { faInfoCircle } from '@rtkwlf/pro-solid-svg-icons/faInfoCircle';

export const alertTheme: Pick<Components<Theme>, 'MuiAlert'> = {
  MuiAlert: {
    defaultProps: {
      iconMapping: {
        // These icons are required to match all products status indicators
        error: <FontAwesomeIcon icon={faExclamationTriangle} size="xs" />,
        info: <FontAwesomeIcon icon={faInfoCircle} size="xs" />,
        success: <FontAwesomeIcon icon={faCheckCircle} size="xs" />,
        warning: <FontAwesomeIcon icon={faDiamondExclamation} size="xs" />,
      },
    },
    styleOverrides: {
      root: {
        // make content wrap to prevent action button from dropping to multiple lines
        flexWrap: 'wrap',
        // prevent the content from squishing and close icon button from dropping under message
        minWidth: 255,
      },
      icon: ({ theme }) => ({
        // icon color needs to be inverted
        color: (theme.vars || theme).palette.action.active,
      }),
      message: {
        // prevent message from taking all the space when space is limited
        // allows the close icon button to remain at the top
        flex: '1 1 150px',
      },
    },
  },
};
